import React from "react";
import InputFormStyle from "../style/input_form.component";
import { InputFormProps } from "./interface/formInterface";

const FormPrize = (props: InputFormProps) => {
  const { value, setValue, label, width, height, fontSize } = props;
  const { prize, prizeUnit, setValue2, label2 } = value;
  return (
    <div
      style={{
        width: width,
        marginTop: "10px",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div style={{ width: "80%" }}>
        {prize !== "" ? (
          <label style={{ color: "white", fontSize: "12px" }}>{label}</label>
        ) : (
          <label style={{ color: "#1E1E1E", fontSize: "12px" }}>{label}</label>
        )}
        <InputFormStyle
          fontSize={fontSize}
          height={height}
          width="100%"
          value={prize}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          placeholder={label}
        ></InputFormStyle>
      </div>
      <div style={{ width: "20%", marginLeft: "20px" }}>
        {prizeUnit !== "" ? (
          <label style={{ color: "white", fontSize: "12px" }}>{label2}</label>
        ) : (
          <label style={{ color: "#1E1E1E", fontSize: "12px" }}>{label2}</label>
        )}
        <InputFormStyle
          fontSize={fontSize}
          height={height}
          width="100%"
          value={prizeUnit}
          onChange={(e) => {
            setValue2(e.target.value);
          }}
          placeholder={label2}
        ></InputFormStyle>
      </div>
    </div>
  );
};

export default FormPrize;
